import moment from 'moment';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { POINT_TIER } from 'utils/constants';

export default function GamificationDetail({ data }) {
  const bonus_point = 'bonus_point';
  const minimunLength = 0;
  const isPointTier = useMemo(() => {
    const isPointTier = POINT_TIER.YES;
    return data?.is_point_tier === isPointTier;
  }, [data]);

  return (
    <div>
      <h2 className="pt-5 pl-5 font-semibold text-purple-800">Point Detail</h2>
      <div className="px-5 py-2 grid grid-cols-2">
        <div className="py-3 text-sm font-semibold border-b">Start From</div>
        <div className="py-3 text-sm border-b">
          {moment(data.start_at).format('DD MMMM YYYY HH:mm')}
        </div>
        <div className="py-3 text-sm font-semibold border-b">Created By</div>
        <div className="py-3 text-sm border-b">{data.created_by}</div>
        <div className="py-3 text-sm font-semibold border-b">Created At</div>
        <div className="py-3 text-sm border-b">
          {moment(data.created_at).format('DD MMMM YYYY HH:mm')}
        </div>
        <div className="py-3 text-sm font-semibold">Points</div>
        <div className="pb-3 text-sm">
          {data?.gamification_point_map?.map((map) => (
            <div key={map?.id} className="pb-3 border-b">
              <h3 className="py-3 px-3 font-bold bg-gray-100">
                {isPointTier ? map?.tier_name : 'Default Point'}
              </h3>
              <hr className="pb-3" />
              <div className="grid grid-cols-4">
                {Object.keys(map)
                  .filter((x) => x?.startsWith('point_') || x === bonus_point)
                  .map((key) => {
                    if (key === bonus_point) {
                      return (
                        <div key={`${map?.id}--${map.tier_name}-${key}`}>
                          <h5>Bonus Point</h5>

                          <span className="text-gray-500">
                            {map[key] > minimunLength ? map[key] : '-'}
                          </span>
                        </div>
                      );
                    }

                    const point = key.split('_')?.[1];
                    return (
                      <div key={`${map?.id}--${map.tier_name}-${key}`}>
                        <h5>{`Hari ke ${point}`}</h5>

                        <span className="text-gray-500">
                          {map[key] > minimunLength ? map[key] : '-'}
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

GamificationDetail.propTypes = {
  data: PropTypes.object.isRequired
};
